module.exports = __webpack_public_path__ + "img/standup-up.b3d3b2fa.svg";